import {Navigate, useLocation} from "react-router";
import {create} from "../errorPageUrl";
import {ErrorCode} from "./ErrorDisplay";

type Props = {
    id: string;
    code?: ErrorCode;
};

const RedirectToError = ({code = 404, id}: Props) => {
    const location = useLocation();
    return <Navigate to={create(code, id, location.pathname)} />;
};

export default RedirectToError;
